import { useTranslation } from 'react-i18next'
import { useAuth } from "../Providers/AuthProvider"
import { useParams } from "../Providers/ParamsProvider"
import { useState } from 'react'
import { toast } from 'react-toastify'

const AgreementsControl = ({ children }) => {
    const { t } = useTranslation()
    const { authState, logout, handleUpdateAcceptedAgreementsVersion } = useAuth()
    const { agreementsVersion } = useParams()

    const [isRegulationsAccepted, setIsRegulationsAccepted] = useState(false)
    const [isOwsAccepted, setIsOwsAccepted] = useState(false)
    const [isRegulationsDownloaded, setIsRegulationsDownloaded] = useState(false)
    const [isOwsDownloaded, setIsOwsDownloaded] = useState(false)

    const handleDownloadPolicy = (policy) => {
        let consentLink = ''
        switch (policy) {
            case "terms_and_conditions_of_the_trading_portal":
                setIsRegulationsDownloaded(true)
                consentLink = '/Statements/TG/Regulamin Portalu Transakcyjnego E-Handel.pdf'
                window.open(consentLink, '_blank')
                break
            case "terms_and_conditions_OWS":
                setIsOwsDownloaded(true)
                consentLink = '/Statements/TG/OWS.pdf'
                window.open(consentLink, '_blank')
                break
        }
    }

    const handleChange = (e) => {
        const { id, checked } = e.target
        if (id === "terms_and_conditions_of_the_trading_portal" && !isRegulationsAccepted && !isRegulationsDownloaded) {
            setIsRegulationsDownloaded(true)
            handleDownloadPolicy('terms_and_conditions_of_the_trading_portal')
        }
        else if (id === "terms_and_conditions_OWS" && !isOwsAccepted && !isOwsDownloaded) {
            setIsOwsDownloaded(true)
            handleDownloadPolicy('terms_and_conditions_OWS')
        }
        if (id == 'terms_and_conditions_of_the_trading_portal') {
            setIsRegulationsAccepted(checked)
        }
        else {
            setIsOwsAccepted(checked)
        }
    }

    const handleConfirm = async () => {
        if (isRegulationsAccepted && isOwsAccepted) {
            let res = await handleUpdateAcceptedAgreementsVersion(authState.user.userId, agreementsVersion)
            if (!res) {
                toast.error('Nie udało się zapisać zmian! Skontaktuj się z administratorem wytryny!')
                return
            }
        }
        else {
            toast.warning('Proszę zaakceptować wszystkie dokumenty!')
            return
        }
    }

    if (authState && authState.user && !authState.user.isOperator && (authState.user.acceptedAgreementsVersion != agreementsVersion)) {
        return (<div className="container-fluid-with-paddings mt-4">
            <div className="main-container-holder">
                <div className="row">
                    <div className="col-12 col-xxl-3">
                        <img src='/CompanyMainLogo.png' alt='logo' height={68} style={{ padding: '5px' }} />
                    </div>
                    <div className="col-12 col-xxl-9 mt-4 mt-xxl-0 d-flex flex-column">
                        <h4>Uwaga!</h4>
                        <h4>Zmienilismy wersje naszych dokumentów.</h4>
                        <h4>Aby dalej korzystać z eHandlu prosze zaakceptowac nowe wersję dokumentów.</h4>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className='row justify-content-center'>
                        <div className="consent-checkbox">
                            <input type="checkbox" id="terms_and_conditions_of_the_trading_portal" className="checkbox-custom" checked={isRegulationsAccepted}
                                onChange={handleChange} />
                            <span>
                                {t("terms_and_conditions_of_the_trading_portal")}
                                <span className='error-text-color'> *</span>
                            </span>
                            <div className="d-flex ms-2">
                                <span className='app-link m-0 p-0' onClick={() => handleDownloadPolicy('terms_and_conditions_of_the_trading_portal')}>{t("download")}</span>
                            </div>
                        </div>

                        <div className="consent-checkbox">
                            <input type="checkbox" id="terms_and_conditions_OWS" className="checkbox-custom" checked={isOwsAccepted}
                                onChange={handleChange} />
                            <span>
                                {t("terms_and_conditions_OWS")}
                                <span className='error-text-color'> *</span>
                            </span>
                            <div className="d-flex ms-2">
                                <span className='app-link m-0 p-0' onClick={() => handleDownloadPolicy('terms_and_conditions_OWS')}>{t("download")}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-5 d-flex" style={{ marginRight: '10%', marginLeft: '10%' }}>
                    <button className="btn-app-primary" onClick={handleConfirm}>Zatwierdź</button>
                    <button onClick={() => logout()} className="btn-app-secondary mt-2">Wyloguj się</button>
                </div>
            </div>
        </div>)
    }
    else {
        return children
    }
}

export default AgreementsControl